// extracted by mini-css-extract-plugin
export default {"kvkk":"kvkk_kvkk__5Fflf","frame":"kvkk_frame__v+Guq"};